exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#list {\n  box-shadow: 1px 1px 10px rgba(0,0,0,.5);\n}\n\n.topic-item {\n  padding: 0.9em 1em;\n  border-left: 6px solid transparent;\n  border-bottom: 1px solid #B6B6B6;\n}\n\n.topic-item.active {\n  background: #eee;\n}\n\n.topic-item h5 {\n  margin-left: 5px;\n}\n\n.load-more {\n  display: block;\n  padding: 10px;\n  text-align: center;\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/topic-list.vue
 ** module id = 27
 ** module chunks = 0
 **/